.linkedinHeader {
  background-image: url(/linkedin-profile.svg);
  background-repeat: no-repeat;
  background-size: 50px 50px;
  background-position: left center;
  height: 50px;
  padding-left: 60px;
  line-height: 16px;
}

.headerSubText {
  color: var(--linkedin-header-sub-text);
  font-size: 0.8em;
  font-weight: 400;
}

.headerSubText svg {
  width: 16px;
  height: 16px;
  vertical-align: sub;
}

.headerSubText .centerDot {
  font-weight: bold;
  font-size: 1rem;
}

.yourTake {
  color: var(--main-text);
}

.linkBox {
  border: 1px solid var(--linkedin-link-box-border);
  border-radius: 8px;
  padding: 14px;
}

.linkTitle {
  font-weight: 600;
}

.linkSourceDomain {
  color: var(--linkedin-header-sub-text);
  font-size: 0.9em;
}
